// src/components/HomeRedirect.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth"; // o de donde obtengas el usuario

export default function HomeRedirect() {
  const { auth } = useAuth(); // auth = null si no hay sesión
  const location = useLocation();

  if (localStorage.getItem("accessToken")) {
    return <Navigate to="/dashboard" replace />;
  } else {
    return <Navigate to="/convenios-aprobados" replace />;
  }
}
